import { useAppSelector } from "src/store/hooks";
import coachIcon from '../../static/icons/icon_coach.svg';
import contactIcon from '../../static/icons/icon_contact.svg';
import infoIcon from '../../static/icons/icon_info.svg';
import modulesIcon from '../../static/icons/icon_modules.svg';
import protocolIcon from '../../static/icons/icon_protocol.svg';
import questionMarkIcon from '../../static/icons/icon_question_mark.svg';
import settingsIcon from '../../static/icons/icon_settings.svg';
import starIcon from '../../static/icons/icon_star.svg';

const topBarIcons: Record<string, string> = {
    'icon_coach.svg': coachIcon,
    'icon_contact.svg': contactIcon,
    'icon_info.svg': infoIcon,
    'icon_modules.svg': modulesIcon,
    'icon_protocol.svg': protocolIcon,
    'icon_question_mark.svg': questionMarkIcon,
    'icon_settings.svg': settingsIcon,
    'icon_star.svg': starIcon
};

type TopBarProps = {
    title?: string;
    leftButtons?: JSX.Element[];
    rightButtons?: JSX.Element[];
    icon?: string;
};

const TopBar = (props: TopBarProps) => {
    const config = useAppSelector(state => state.globalState.config);

    let icon = <></>;
    if (props.icon !== undefined && topBarIcons[props.icon]) {
        icon = <img className="topbar-title-icon" src={topBarIcons[props.icon]} />;
    }

    let title = <></>;
    if (props.title !== undefined) {
        title = <span className="topbar-title-text">{props.title}</span>;
    }

    return (
        <div className="topbar" style={{ backgroundColor: config?.themeColor || "#ffffff" }}>
            <div className="topbar-left">
                {props.leftButtons?.map((button, index) => {
                    return <div key={index}> {button} </div>;
                })}
            </div>

            <div className="topbar-center">
                {icon}
                {title}
            </div>

            <div className="topbar-right">
                {props.rightButtons?.map((button, index) => {
                    return <div key={index}> {button} </div>;
                })}
            </div>
        </div>
    );
}

export default TopBar;
